import { useCallback } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import ObjectActionCreators from '../../../actions';
import { BANDS_CONFIG, NUM_LEVEL } from '../../../constants/layout';
import {
  scrollXSelector,
  isPerspectivesPanelOpenSelector,
  zoomSelector,
} from '../../../reducers/layoutReducer/layoutSelector';

export const PANEL_CONFIG_WIDTH_OFFSET = 37;
export const PANEL_CONFIG_WIDTH_LEVEL_OFFSET = 11;
const OFFSET_PANEL_PERSP_OPEN = 380;
const OFFSET_PANEL_PERSP_CLOSE = 100;

export const usePanelsConfig = () => {
  const dispatch = useDispatch();
  // Sélectionne panels avec shallowEqual pour éviter les re-renders inutiles
  const panelsConfig = useSelector(
    (state) => state.objects.panels,
    shallowEqual
  );
  const zoom = useSelector(zoomSelector) / 100.0;
  const scrollX = useSelector(scrollXSelector);
  const isPerspectivesPanelOpen = useSelector(isPerspectivesPanelOpenSelector);

  const updatePanelConfig = useCallback(
    (indexParam, posX) => {
      let initX =
        (isPerspectivesPanelOpen
          ? OFFSET_PANEL_PERSP_OPEN
          : OFFSET_PANEL_PERSP_CLOSE) / zoom;
      const index = indexParam - 1;

      const adjustedPosX = posX / zoom;
      // Compute the cumulative width of previous panels
      const colsBeforeWidth = panelsConfig
        .slice(0, index)
        .reduce((sum, p) => sum + p.width, 0);

      // Compute new width for the current panel
      const newWidth = Math.max(
        BANDS_CONFIG[index].minWidth,
        adjustedPosX - initX - colsBeforeWidth + scrollX
      );

      const offset =
        PANEL_CONFIG_WIDTH_OFFSET +
        11 * PANEL_CONFIG_WIDTH_LEVEL_OFFSET * index;

      document.documentElement.style.setProperty(
        `--resizer-${index}-posx`,
        `${newWidth - offset}px`
      );

      // Ensure only the current panel and following ones are updated
      const updatedPanels = panelsConfig.map((item, indmap) => ({
        width: indmap === index ? newWidth : item.width,
      }));

      dispatch(ObjectActionCreators.setPanels(updatedPanels));
    },
    [panelsConfig, isPerspectivesPanelOpen, scrollX, dispatch]
  );

  return { panelsConfig, updatePanelConfig };
};
